export default __webpack_public_path__ + "static/media/terms.f725d815.txt";